<template>
    <div class="md-layout">
        <div class="md-layout-item">
            <!-- Search / Primary Filter Section -->
            <md-card class="qc-card qc-search-card">
                <md-card-content>
                    <div class="qc-search-row">
                        <!-- Search-by radio pills -->
                        <div class="qc-search-left">
                            <p class="qc-search-label">Search by</p>

                            <div class="search-options">
                                <ul>
                                    <li v-for="(r, i) in [
                                        { label: 'Order Number', value: 'on' },
                                        { label: 'PO #', value: 'po' },
                                        { label: 'SKU', value: 'sku' },
                                    ]" :key="i">
                                        <input type="radio" v-model="selectedSearchBy" :value="r.value" />
                                        <span>{{ r.label }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- Search input -->
                        <div class="qc-search-input-wrapper">
                            <md-field class="qc-search-field">
                                <md-input type="search" id="search-input" clearable
                                    placeholder="Search records here... Press enter to search" v-model="searchVal"
                                    @keypress="handleSearch($event)"></md-input>
                            </md-field>
                        </div>

                        <!-- Search actions -->
                        <div class="qc-search-actions">
                            <md-button @click="handleSearch('click')" class="qc-btn qc-btn-primary">
                                Search
                            </md-button>
                            <md-button class="qc-btn qc-btn-secondary" @click="clearFilters">
                                Clear
                            </md-button>
                        </div>
                    </div>
                </md-card-content>
            </md-card>

            <!-- Advanced Filters -->
            <md-card class="qc-card qc-filters-card light">
                <md-card-content>
                    <div class="filters">
                        <div v-if="!activeUser.customerID" class="filter customer">
                            <p>Vendors</p>
                            <v-select @input="handleFilter" :appendToBody="true" :deselectFromDropdown="true"
                                v-model="filterBy.customers" :options="customers" label="name" :reduce="(t) => t.name"
                                :closeOnSelect="true" />
                        </div>

                        <div v-else class="filter customer">
                            <p>Sub Vendors</p>
                            <v-select @input="handleFilter" :appendToBody="true" :deselectFromDropdown="true"
                                v-model="filterBy.client" :options="clients" :closeOnSelect="true" />
                        </div>


                        <div class="filter">
                            <p>Start From</p>
                            <md-datepicker class="datepicker" @input="validateDateRange('startDate')"
                                v-model="filterBy.startDate" />
                        </div>

                        <div class="filter">
                            <p>End To</p>
                            <md-datepicker class="datepicker" @input="validateDateRange('endDate')"
                                v-model="filterBy.endDate" />
                        </div>

                        <div class="bottom-row">
                            <div class="filter filter-status">
                                <p>Filter Items:</p>
                                <div class="status-tags">
                                    <span>That Failed</span>
                                    <md-checkbox @change="handleFilter" v-model="filterBy.showFailedItems" />

                                    <span>That Passed-W/R</span>
                                    <md-checkbox @change="handleFilter" v-model="filterBy.showPassedWithRepair" />


                                    <span>Has Been Shipped</span>
                                    <md-checkbox @change="handleShippingFilter('showShippedItems')"
                                        v-model="filterBy.showShippedItems" />

                                    <span>Pending Shipping</span>
                                    <md-checkbox @change="handleShippingFilter('showPendingShipping')"
                                        v-model="filterBy.showPendingShipping" />
                                </div>
                            </div>

                            <div class="filter filter-row-extra">
                                <span>Has Been Q/A</span>
                                <md-checkbox v-model="filterBy.hidePendingQA" @change="handleFilter" />
                            </div>

                            <div class="filter filter-btn">
                                <!-- <md-button class="qc-btn qc-btn-primary" @click="handleFilter">
                                    Filter
                                </md-button> -->
                                <md-button class="qc-btn qc-btn-secondary" @click="clearFilters">
                                    Clear
                                </md-button>
                            </div>
                        </div>
                    </div>
                </md-card-content>
            </md-card>

            <!-- Data Table Section -->
            <md-card class="qc-card qc-table-card">
                <md-card-content>
                    <div class="qc-table-header">
                        <div class="btn-row stats_holder">
                            <md-button :class="showExportOptions
                                ? 'md-accent'
                                : 'md-primary md-round md-small'
                                " @click="
                                    () => {
                                        if (showExportOptions) {
                                            showExportOptions = false;
                                            showSelectableTable = false;
                                            selectedExportData = [];
                                        } else {
                                            showExportOptions = true;
                                        }
                                    }
                                ">
                                {{ showExportOptions ? "Cancel" : "Export" }}
                            </md-button>
                            <div v-if="showExportOptions" class="qc-export-options">
                                <md-button @click="exportCSV('all')" class="md-primary">
                                    Export All Table Data
                                </md-button>
                                <md-button class="md-primary" @click="showSelectableTable = !showSelectableTable">
                                    Export Selected Items
                                </md-button>
                            </div>
                        </div>
                    </div>

                    <div class="qc-table-wrapper">
                        <!-- Custom QC Table (replacing md-table) -->
                        <!-- ITEM-LEVEL TABLE: one row per item, not per order. -->
                        <table v-if="!showSelectableTable" class="qc-table">
                            <thead>
                                <tr>
                                    <th @click="sortBy('Date')">Date</th>
                                    <th @click="sortBy('OrderNum')">DIS Order #</th>
                                    <th v-if="!activeUser.customerID">
                                        Vendor
                                    </th>
                                    <th v-else>
                                        Sub Vendor
                                    </th>
                                    <th @click="sortBy('PO')">PO #</th>
                                    <th @click="sortBy('SKU')">SKU</th>
                                    <th @click="sortBy('Type')">Type</th>
                                    <th @click="sortBy('Status')">QA Status</th>
                                    <th>QA Notes</th>
                                    <th>QA Images</th>
                                    <th @click="sortBy('HasBeenShipped')">Shipped</th>

                                </tr>
                            </thead>

                            <tbody>
                                <!-- LOADING STATE -->
                                <tr v-if="itemRowsLoading">
                                    <td :colspan="totalColumnCount" style="text-align:center; padding: 24px;">
                                        Loading item results&hellip;
                                    </td>
                                </tr>

                                <!-- ERROR STATE (partial or total failure fetching items for this page) -->
                                <tr v-else-if="itemRowsError && !displayedRows.length">
                                    <td :colspan="totalColumnCount"
                                        style="text-align:center; padding: 24px; color: #b91c1c;">
                                        {{ itemRowsError }}
                                    </td>
                                </tr>

                                <!-- EMPTY STATE -->
                                <tr v-else-if="!displayedRows.length">
                                    <td :colspan="totalColumnCount" style="text-align:center; padding: 24px;">
                                        No items found for the current orders/filters.
                                    </td>
                                </tr>

                                <template v-else>
                                    <tr v-if="itemRowsError" class="qc-partial-error-row">
                                        <td :colspan="totalColumnCount"
                                            style="text-align:center; padding: 8px; color: #b91c1c;">
                                            {{ itemRowsError }}
                                        </td>
                                    </tr>

                                    <!-- MAIN TABLE ROW (one per item) -->
                                    <tr v-for="row in queriedData" :key="row._rowKey" class="qc-main-row"
                                        :class="{ 'failed-item-row': row.Status === 'Failed' }">
                                        <td>{{ row.Date | format_date_time }}</td>
                                        <td>{{ row.OrderNum }}<span v-if="row.LineNum">-{{ row.LineNum }}</span></td>
                                        <td translate="no" v-if="!activeUser.customerID">
                                            {{ row.Vendor || 'N/A' }}
                                        </td>
                                        <td translate="no" v-else>
                                            {{ row.SubVendor || 'N/A' }}
                                        </td>
                                        <td>
                                            {{ row.PO || 'N/A' }}
                                        </td>

                                        <td>{{ row.SKU }}</td>
                                        <td>{{ row.Type || 'N/A' }}</td>
                                        <td>{{ row.Status === 'Needs Q/A' ? 'Pending' : row.Status }}</td>

                                        <td>
                                            <div class="qc-notes-cell">
                                                <div v-if="row.Notes" class="notes">{{ row.Notes }}</div>
                                                <div v-else class="no-data">N/A</div>
                                            </div>

                                        </td>

                                        <td>
                                            <div class="qc-notes-cell">
                                                <button v-if="row.Images && row.Images.length" @click="
                                                    (showItemImagesModal = true),
                                                    (selectedFailedItem = row._raw),
                                                    (selectedItemType = 'failed')
                                                    " class="btn all-text-btn">
                                                    View
                                                </button>
                                                <div v-else class="no-data">N/A</div>
                                            </div>
                                        </td>

                                        <td>

                                            <div v-if="row.HasBeenShipped" style="font-weight: 900; color: green;">
                                                {{ row.ShippedOn | format_date_time }}</div>
                                            <div v-else-if="row.ServiceType.includes('DropShip')">Hasn't Been Shipped
                                            </div>
                                            <div v-else>N/A</div>
                                            <sub v-if="row.HasBeenShipped"
                                                style="text-decoration: underline; color: #253C6E !important;">
                                                <a style="color: #253C6E !important;"
                                                    :href="`https://www.ups.com/track?loc=en_US&tracknum=${encodeURIComponent(row.TrackingNum)}`"
                                                    target="_blank" rel="noopener noreferrer">
                                                    {{ row.TrackingNum }}
                                                </a>
                                            </sub>


                                        </td>

                                    </tr>
                                </template>
                            </tbody>
                        </table>

                        <!-- keep your SelectableTable branch unchanged -->
                        <SelectableTable v-else @onSelected="onSelected" :tableData="tableData"
                            :tableInfo="exportItemsInfo">
                            <template v-slot:btns>
                                <md-button v-if="selectedExportData.length" class="qc-button"
                                    @click="exportCSV('selected')">
                                    Export
                                </md-button>
                            </template>
                        </SelectableTable>
                    </div>
                </md-card-content>

                <md-divider></md-divider>

                <md-card-actions md-alignment="space-between">
                    <div class="per-page" :style="{ marginBottom: '20px', marginTop: '20px' }">
                        <!-- <label for="orders">Per page</label>
                        <div>
                            <select style="border: none !important" v-model="pagination.perPage" name="orders">
                                <option v-for="item in pagination.perPageOptions" :key="item" :label="item"
                                    :value="item">
                                    {{ item }}
                                </option>
                            </select>
                        </div> -->


                        <p class="card-category">
                            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
                        </p>
                    </div>


                    <Pagination class="pagination-no-border pagination-success" v-model="pagination.currentPage"
                        :per-page="pagination.perPage" :total="total" @update-table="fetchItems"
                        :allowClick="Boolean(tableData.length + searchedData.length)"></Pagination>
                </md-card-actions>
            </md-card>




            <!-- Modal for Displaying Failed Item Images  -->
            <Modal @close="closeImageModal" :showDialog="showItemImagesModal" :showBackBtn="true"
                @back="goBack('showItemImagesModal', 'showOrderReportModal')">
                <template v-slot:modalContent>
                    <md-card>
                        <md-card-content>
                            <MultImages :media="selectedFailedItem.Images" :item="selectedFailedItem" />
                        </md-card-content>
                    </md-card>
                </template>
            </Modal>


            <input id="barcode-input" ref="barcodeInput" autofocus type="search" style="opacity: 0"
                placeholder="Search or Scan records here" />
        </div>

        <md-snackbar md-position="center" :md-duration="5000" :md-active.sync="showSnackbar" md-persistent>
            <span>{{ snackbarMsg }}</span>
        </md-snackbar>
    </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment";
import Pagination from "@/components/Pagination.vue";
import Modal from "@/components/Modal.vue";
import SelectableTable from "@/components/SelectableTable.vue";
import MultImages from "@/components/Inputs/UploadMultiple.vue";
import { db } from "@/config/firebaseInit.js";

const ExcelJS = require("exceljs");
const { DateTime } = require("luxon");

// ---- Put these above `export default` in the component ----
const CERT_SERVICE_TYPE = "Screening,QA,Certificate,DropShip";

// The viewer's time zone from the browser, e.g. "Europe/Dublin" or "America/Chicago".
function getUserZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York";
}

// Toggle → Status value. Verify "Passed" matches what's stored in Firestore.
const STATUS_TOGGLES = {
    showFailedItems: "Failed",
    showPassedWithRepair: "Passed-W/Repair",
    showPassedItems: "Passed",
};

// Treat the picked date as a calendar date in the given zone.
function toZonedDate(value, zone) {
    if (value instanceof Date) {
        return DateTime.fromObject(
            { year: value.getFullYear(), month: value.getMonth() + 1, day: value.getDate() },
            { zone },
        );
    }
    return DateTime.fromISO(value, { zone });
}

export default {
    name: "Home",
    components: {
        Pagination,
        Modal,
        MultImages,
        SelectableTable,
    },
    computed: {
        /***
         * Returns a page from the searched data or the whole data.
         * NOTE: this is a page of ORDERS. Item rows are hydrated from this
         * page's orders in `hydrateItemRows` (see watch below) and rendered
         * via `displayedRows`. Pagination therefore advances by "orders per
         * page", not "items per page" -- see README note in PR description
         * for why (Firestore items subcollections don't carry the order's
         * Timestamp, so item-level cursor pagination isn't available without
         * a schema change).
         */
        queriedData() {
            let result = this.tableData;
            if (this.searchedData.length > 0) {
                result = this.searchedData.slice(this.from, this.to);
            }
            return result;
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.searchedData.length > 0
                ? this.searchedData.length
                : this.tableSize;
        },

        totalColumnCount() {
            // Date, Order#, SKU, Cert/Item#, Type, QA Status, QA Results, QA Images, Shipped, Controls
            let cols = 10;
            if (!this.activeUser?.customerID) cols++; // Vendor column
            if (this.tableDataToDisplay["Purchase Order"]) cols++;
            if (this.tableDataToDisplay["QA Notes"]) cols++;
            if (this.activeUser?.isDeveloper) cols++;
            return cols;
        },

        // Item-level rows for the current page of orders, sorted client-side.
        displayedRows() {
            const rows = this.tableData
            return rows.sort((a, b) => {
                const field = this.currentSort;
                const dir = this.currentSortOrder === "asc" ? 1 : -1;

                const av = a[field] ?? "";
                const bv = b[field] ?? "";

                if (typeof av === "number" && typeof bv === "number") {
                    return (av - bv) * dir;
                }
                return String(av).localeCompare(String(bv)) * dir;
            });
        },

        unfilteredAllOrderItemsInfo() {
            let results = {};

            if (this.searchValueForAllOrderItems.length) {
                this.searchValueForAllOrderItems.forEach((item) => {
                    results[item.ItemNum] = item;
                });
            } else {
                results = this.allOrderItemsInfo;
            }
            return results;
        },
    },

    data() {
        return {
            itemsQueryRef: null,
            selectedRejection: "",
            selectedOrderForDuplication: {},
            imageView: null,
            jewelryType: "Ring",
            selectedItemToExpand: null,
            showTableMenu: false,
            expandedRows: {},
            currentSort: "Date",
            currentSortOrder: "desc",
            activeUser: {},
            selectedItemType: "",
            pagination: {
                perPage: 250,
                currentPage: 1,
                perPageOptions: [50, 100, 250],
                total: 0,
            },
            searchQuery: "",
            searchVal: "",
            selectedSearchBy: "on",
            selectedSearchByForAllOrderItems: "LineNum",
            allItemsForAuthentication: [],
            // Item-level rows no longer need to hide arrays behind toggles
            // (each row shows a single PO/SKU/etc.), so this list only
            // covers columns that are genuinely optional/verbose.
            tableOptions: ["Purchase Order", "QA Notes"],
            isBeingHandledThroughAuthWindow: false,
            tableDataToDisplay: {
                "Purchase Order": false,
                "QA Notes": false,
            },
            selectedTableOptions: [],
            filterBy: {
                showFailedItems: false,
                showPassedItems: false,
                showShippedItems: false,
                showPendingShipping: false,
                showPassedWithRepair: false,
                showCertificateOrders: false,
                // When true, items with Status "Needs Q/A" are excluded from
                // item-row hydration (mirrors exportCSV's existing default
                // filter). Off by default so behavior doesn't silently change.
                hidePendingQA: false,
                status: "",
                customers: "",
                startDate: "",
                endDate: "",
            },
            tableSize: 0,
            totalOrders: 0,
            propsToSearch: ["title", "fullname", "description"],
            showModalContentForLineItem: false,
            showQAAssociateModal: false,
            showModalContentForItem: false,
            selectedQaAssociate: "",
            allQaAssociates: [],
            showImageModal: false,
            showSelectableTable: false,
            showSnackbar: false,
            statusForAllItems: null,
            showChangesBtn: false,
            allFailedItems: [],
            allItemsForSelectedLine: [],
            selectedLineItem: {},
            selectedItem: {},
            selectedFailedItem: {},
            showModalContent: false,
            showExportOptions: false,
            selectedExportData: [],
            searchValueForAllOrderItems: [],
            searchAuthItems: null,
            popupTab: null,
            lineItemsInfo: [
                {
                    label: "Line #",
                    key: "LineNum",
                },
                {
                    label: "Qty",
                    key: "Quantity",
                },
            ],
            itemsInfo: [
                {
                    label: "Line #",
                    key: "LineNum",
                },
                {
                    label: "Item #",
                    key: "ItemNum",
                },
                {
                    label: "Vendor",
                    key: "Customer",
                },
                {
                    label: "SKU",
                    key: "SKU",
                },

                {
                    label: "Cert #",
                    key: "CertNum",
                },

                {
                    label: "Type",
                    key: "Type",
                },

                {
                    label: "Status",
                    key: "Status",
                },
            ],

            exportItemsInfo: [
                {
                    label: "Order #",
                    key: "OrderNum",
                },
                {
                    label: "Vendor",
                    key: "Customer",
                },
                {
                    label: "Sub Vendor",
                    key: "Client",
                },

                {
                    label: "Quantity",
                    key: "Quantity",
                },
                {
                    label: "FailedItems",
                    key: "FailedItems",
                },
                {
                    label: "Status",
                    key: "Status",
                },
            ],
            unfilteredItems: [],
            tableData: [],
            // Item-level rows hydrated from the current page of orders (see
            // hydrateItemRows). This -- not tableData/searchedData -- is what
            // the primary table renders.
            itemRows: [],
            itemRowsLoading: false,
            itemRowsError: null,
            selectedOrderLineStatus: [],
            allLineItems: [],
            searchedData: [],
            selectedItems: [],
            customers: [],
            clients: [],
            showDialog: false,
            showQCModal: false,
            showQCModalForMult: false,
            showAuthModal: false,
            showOrderReportModal: false,
            showItemImagesModal: false,
            showNoteModal: false,
            allOrderItemsInfo: {},
            selectedOrder: {},
            ordersRef: {},
            leftQCPanelInit: false,
            showAuthViewModal: false,
            qcResponses: {
                rejections: [],
                notes: "",
            },
            snackbarMsg: "",
            inputValue: "",
            barcodeValue: "",
            imageSize: "100%",
            allLineItemsUnfiltered: [],
            // routeChange: true,
        };
    },

    async created() {
        this.activeUser = this.$store.state.user;
        if (this.$store.state.user.customerID && this.$store.state.user.isCustomer) {
            const customerID = this.$store.state.user.customerID;
            this.itemsQueryRef = db.collectionGroup("items").where("Customer", "==", customerID);
            this.fetchClients(customerID)
            this.$bind("null", db.doc(`/analytics/itemQuantities/vendors/${customerID}`)).then((doc) => {
                this.tableSize = doc.totalItems;

            });
        } else if (this.$store.state.user.clientID && this.$store.state.user.isClient) {
            let clientID = this.$store.state.user.clientID;
            this.itemsQueryRef = db.collectionGroup("items").where("Client", "==", clientID);
            this.fetchCustomers()
            this.$bind("null", db.doc(`/analytics/itemQuantities/clients/${clientID}`)).then((doc) => {
                this.tableSize = doc.totalItems;

            });
        }

        this.fetchItems("start");
        this.originPath = window.location.origin;
    },

    watch: {
        selectedRejection(newValue) {
            if (!newValue) return;

            try {
                // We keep the folder path static so Webpack can index the directory
                // The @ alias usually points to the 'src' directory
                this.imageView = require(`@/assets/img/${this.jewelryType}/${newValue}.png`);
            } catch (e) {
                console.error("Image not found", e);
                this.showImageModal = false;
                this.showItemImagesModal = true;
                this.imageView = ""; // Fallback to a placeholder
            }
        },

        selectedItem(item) {
            if (item.Type) this.jewelryType = item.Type.trim();
        },

        selectedTableOptions: {
            deep: true,
            handler(selected) {
                this.tableDataToDisplay = {
                    "Purchase Order": false,
                    "QA Notes": false,
                };
                selected.forEach((option) => {
                    this.tableDataToDisplay[option] = true;
                });
            },
        },



    },
    beforeUnmount() {
        // window.removeEventListener("keydown", this.handleBarcodeScanned);
    },
    mounted() {
        // window.addEventListener("keydown", this.handleBarcodeScanned);
        this.$nextTick(() => {
            const inputElement = this.$refs.barcodeInput.$el;
            if (inputElement && typeof inputElement.focus === "function") {
                inputElement.focus();
            }
        });
    },
    methods: {
        async fetchQAReasons(orderId, itemId) {
            const qaRef = await db.doc(`orders/${orderId}/quality_control/${itemId}`).get()
            if (!qaRef.exists) {
                return ""
            }
            return qaRef.data()
        },
        async fetchClients(customerID) {
            let currentCustomer = await db.doc(`customers/${customerID}`).get()
            const { clients, clientID } = currentCustomer.data()
            this.clients = clients || [clientID]


        },
        handleSKUFormat(sku) {
            if (sku.includes("-P_") || sku.includes("-D_")) {
                return sku.split("-")[0];
            } else {
                return sku || 'N/A'
            }
        },
        async fetchCustomers() {
            let customers = await db.collection("customers").get()
            this.customers = customers.docs.filter(d => (
                d.data().clients && d.data().clients.includes(this.$store.state.user.clientID))
                || d.data().clientID == this.$store.state.user.clientID)
                .map(d => Object.assign({ id: d.id, }, d.data()))

        },

        /**
         * Fetches and flattens the `items` (+ matching `quality_control`
         * responses) subcollection for a single order into item-level row
         * objects. Shared by the primary table's hydrateItemRows() below.
         *
         * Never throws: a failure for one order is caught and reported via
         * the returned `error` flag so one bad/inaccessible order can't take
         * down the whole page's table (per the "don't let one malformed item
         * break the table" requirement).
         */
        async fetchItemsForOrder(order) {
            const orderId = order.id;
            try {
                let itemsQuery = db.collection(`orders/${orderId}/items`);
                if (this.filterBy.hidePendingQA) {
                    itemsQuery = itemsQuery.where("Status", "!=", "Needs Q/A");
                }

                if (this.filterBy.showFailedItems) {
                    itemsQuery = itemsQuery.where("Status", "==", "Failed");
                }

                if (this.filterBy.showPassedItems) {
                    itemsQuery = itemsQuery.where("Status", "==", "Passed");
                }

                if (this.filterBy.showPassedWithRepair) {
                    itemsQuery = itemsQuery.where("Status", "==", "Passed-W/Repair");
                }

                if (this.filterBy.showShippedItems) {
                    itemsQuery = itemsQuery.where("HasBeenShipped", "==", true);
                }

                if (this.filterBy.showPendingShipping) {
                    itemsQuery = itemsQuery.where("HasBeenShipped", "==", false);
                }
                if (this.searchVal) {
                    if (this.selectedSearchBy === "po") {
                        itemsQuery = itemsQuery.where("PO", "==", this.searchVal);
                    }

                    if (this.selectedSearchBy === "sku") {
                        itemsQuery = itemsQuery.where("SKU", "==", this.searchVal);
                    }

                    if (this.selectedSearchBy === "cert") {
                        itemsQuery = itemsQuery.where("CertNum", "==", this.searchVal);
                    }
                }


                const [itemsSnap, qcSnap] = await Promise.all([
                    itemsQuery.get(),
                    db.collection(`orders/${orderId}/quality_control`).get(),
                ]);

                const qcById = {};
                qcSnap.forEach((doc) => {
                    qcById[doc.id] = doc.data() || {};
                });

                const rows = itemsSnap.docs.filter(d => !d.id.includes('R')).map((doc) => {
                    const item = doc.data() || {};
                    const qc = qcById[doc.id] || {};
                    return {
                        _rowKey: `${orderId}_${doc.id}`,
                        _itemId: doc.id,
                        _order: order,
                        _raw: Object.assign({ id: doc.id, OrderNum: item.OrderNum || order.OrderNum || orderId }, item),
                        Date: order.Timestamp ?? null,
                        Vendor: item.Customer || order.Customer || "",
                        SubVendor: item.Client,
                        OrderNum: item.OrderNum || order.OrderNum || orderId,
                        LineNum: item.LineNum ?? null,
                        PO: item.PO || "",
                        SKU: this.handleSKUFormat(item.SKU || item.ClientSKU),
                        CertOrItemNum: item.CertNum || item.ItemNum || doc.id,
                        Type: item.Type || "",
                        Status: item.Status || "",
                        ServiceType: item.ServiceType,
                        // Excel's "QA Notes" and "QA Results" are separate
                        // columns (free-text note vs. the rejection-reason
                        // list), so keep them separate here too -- unlike
                        // exportCSV's combined "rejections" cell.
                        Notes: qc.notes || "",
                        Rejections: qc.rejections || [],
                        Images: item.Images || [],
                        HasBeenShipped: !!item.HasBeenShipped,
                        ShippedOn: item.ShippedOn || null,
                        TrackingNum: item.TrackingNum || "",
                    };
                });

                return { rows, error: null };
            } catch (error) {
                console.error(`Failed to load items for order ${orderId}:`, error);
                return { rows: [], error };
            }
        },

        /**
         * Given the current page of order documents, fetches + flattens each
         * order's items into `itemRows`. Runs in chunks of 50 concurrent
         * order-reads (mirrors the batching exportCSV already uses) so a
         * large page doesn't fire hundreds of parallel Firestore reads at
         * once.
         */
        async hydrateItems(itemQuery) {
            return await Promise.all(itemQuery.docs.filter(d => !d.id.includes('R')).map(async (doc) => {
                const item = doc.data() || {};
                const qc = item.Status === "Failed" ? await this.fetchQAReasons(item.OrderNum, doc.id) : ""
                return {
                    _rowKey: `${item.OrderNum}_${doc.id}`,
                    _itemId: doc.id,
                    _raw: item,
                    Date: item.Timestamp,
                    Vendor: item.Customer,
                    SubVendor: item.Client,
                    OrderNum: item.OrderNum,
                    LineNum: item.LineNum,
                    PO: item.PO,
                    SKU: this.handleSKUFormat(item.SKU || item.ClientSKU),
                    CertOrItemNum: item.CertNum || item.ItemNum || doc.id,
                    Type: item.Type || "",
                    Status: item.Status || "",
                    ServiceType: item.ServiceType,
                    // Excel's "QA Notes" and "QA Results" are separate
                    // columns (free-text note vs. the rejection-reason
                    // list), so keep them separate here too -- unlike
                    // exportCSV's combined "rejections" cell.
                    Notes: qc?.notes || "",
                    Rejections: qc?.rejections || [],
                    Images: item.Images || [],
                    HasBeenShipped: !!item.HasBeenShipped,
                    ShippedOn: item.ShippedOn || null,
                    TrackingNum: item.TrackingNum || "",
                };
            }));

        },

        handleRejectionSelection(data) {
            this.qcResponses.rejections = data.selectedRejections
            this.qcResponses.notes = data.description
            this.handleQCChanges()
        },

        handleShippingFilter(key) {

            if (key == 'showShippedItems') {
                this.filterBy.showPendingShipping = false

            }

            if (key == 'showPendingShipping') {
                this.filterBy.showShippedItems = false

            }

            return this.handleFilter()

        },

        fetchRejectionImage(item, rejection) {
            try {
                return require(`@/assets/img/${item.Type}/${rejection}.png`) || "";
            } catch (error) {
                console.log({ error });
                return null;
            }
        },

        openRejectionImage(item, rejection) {
            this.selectedFailedItem = item;
            this.selectedRejection = rejection;
            this.showOrderReportModal = false;
            this.showImageModal = true;
            this.imageSize = "50%";
        },

        async fetchOrder(query) {
            if (!query && this.barcodeValue) query = this.barcodeValue;
            if (query) {
                let orderNum = "";
                let LineNum = "";
                if (query.includes("-")) {
                    orderNum = query.split("-")[0];
                    LineNum = query.split("-")[1];
                }
                this.barcodeValue = "";
                const orderRef = await db.doc(`orders/${orderNum}`).get();
                if (!orderRef.exists) {
                    this.showSearchInputModal = false;

                    return Swal.fire({
                        title: "No Records Found",
                        buttonsStyling: true,
                        html: `<b>No Records</b> has been found. <br/> Please refer to Diamond Track
            and confirm this order exists`,
                    });
                } else {
                    const order = orderRef.data();
                    if (LineNum) {
                        this.selectedOrder = order;

                        let orderLine = await db
                            .doc(`orders/${orderRef.id}/line_items/${LineNum}`)
                            .get();
                        orderLine = orderLine.data();
                        if (orderLine.Items.length > 1) {
                            this.openQC(orderLine.Items[0]);
                        } else {
                            this.handleMultipleItemsQA(orderLine.Items);
                        }
                    } else {
                        this.handleViewModal(order);
                    }
                }
            }
        },

        // handleBarcodeScanned(e) {
        //     let query = null;
        //     if (e.target.id != "search-input") {
        //         if (e.code == "Enter") {
        //             if (this.barcodeValue) {
        //                 query = this.barcodeValue;
        //                 this.fetchOrder(query);
        //             }
        //         }

        //         if (e.key != "Shift" && e.key != "Enter" && e.key !== "Escape") {
        //             this.barcodeValue += e.key;
        //         }
        //     }
        // },

        // sorting helpers
        sortBy(field) {
            if (this.currentSort === field) {
                // toggle direction
                this.currentSortOrder =
                    this.currentSortOrder === "asc" ? "desc" : "asc";
            } else {
                this.currentSort = field;
                this.currentSortOrder = "asc";
            }
        },

        sortClass(field) {
            if (this.currentSort !== field) return "";
            return this.currentSortOrder === "asc" ? "sorted-asc" : "sorted-desc";
        },

        resetTable() {
            this.pagination.currentPage = 1;
            this.searchedData = [];
            this.fetchItems("start")
        },

        async fetchData(action) {
            if (this.searchedData.length) return false;
            if (action == "start") {
                let loader = this.$loading.show({
                    container: null,
                    canCancel: false,
                });
                try {
                    const querySnapshot = this.ordersRef
                        .orderBy("Timestamp", "desc") // Change to your sorting criteria
                        .endAt(0)
                        .limit(this.pagination.perPage);

                    this.$bind("tableData", querySnapshot)
                    loader.hide();
                } catch (error) {
                    loader.hide();
                    console.error("Error fetching data:", error);
                }
            } else if (action == "next") {
                this.fetchNextData();
            } else if (action == "prev") {
                this.fetchPreviousData();
            }
        },

        async fetchNextData() {
            let loader = this.$loading.show({
                container: null,
                canCancel: false,
            });
            let lastDoc = this.tableData[this.tableData.length - 1];
            lastDoc = await db.collection("orders").doc(lastDoc.id).get();
            this.tableData = [];
            try {
                const querySnapshot = await this.ordersRef
                    // .orderBy("Timestamp")
                    .orderBy("Timestamp", "desc") // Change to your sorting criteria
                    .startAfter(lastDoc)
                    .limit(this.pagination.perPage)
                    .get();

                this.tableData = querySnapshot.docs.map((doc) =>
                    Object.assign({ id: doc.id }, doc.data())
                );
                loader.hide();
            } catch (error) {
                console.error("Error fetching data:", error);
                loader.hide();
            }
        },

        async fetchPreviousData() {
            let loader = this.$loading.show({
                container: null,
                canCancel: false,
            });
            let firstDoc = this.tableData[0];
            firstDoc = await db.collection("orders").doc(firstDoc.id).get();
            this.tableData = [];
            try {
                const querySnapshot = await this.ordersRef
                    // .orderBy("created")
                    .orderBy("Timestamp", "asc") // Change to your sorting criteria
                    .startAfter(firstDoc)
                    .limit(this.pagination.perPage)
                    .get();

                this.tableData = querySnapshot.docs
                    .map((doc) => Object.assign({ id: doc.id }, doc.data()))
                    .reverse();
                loader.hide();
            } catch (error) {
                console.error("Error fetching data:", error);
                loader.hide();
            }
        },


        async fetchAllItems() {
            const itemQuery = await this.itemsQueryRef.orderBy("Timestamp", 'desc').get()
            return await this.hydrateItems(itemQuery)
        },

        async fetchItems(action) {
            if (this.searchedData.length) return false;
            if (action == "start") {
                let loader = this.$loading.show({
                    container: null,
                    canCancel: false,
                });
                try {
                    const querySnapshot = await this.itemsQueryRef
                        .orderBy("Timestamp", "desc") // Change to your sorting criteria
                        .endAt(0)
                        .limit(this.pagination.perPage)
                        .get();
                    this.tableData = await this.hydrateItems(querySnapshot)
                    loader.hide();
                } catch (error) {
                    loader.hide();
                    console.error("Error fetching data:", error);
                }
            } else if (action == "next") {
                this.fetchNextItems();
            } else if (action == "prev") {
                this.fetchPreviousItems();
            }
        },

        async fetchNextItems() {
            let loader = this.$loading.show({
                container: null,
                canCancel: false,
            });
            let lastDoc = this.tableData[this.tableData.length - 1];
            console.log({ lastDoc })
            lastDoc = await db.doc(`orders/${lastDoc.OrderNum}/items/${lastDoc._itemId}`).get();
            this.tableData = [];
            try {
                const querySnapshot = await this.itemsQueryRef
                    // .orderBy("Timestamp")
                    .orderBy("Timestamp", "desc") // Change to your sorting criteria
                    .startAfter(lastDoc)
                    .limit(this.pagination.perPage)
                    .get();

                this.tableData = await this.hydrateItems(querySnapshot)
                loader.hide();
            } catch (error) {
                console.error("Error fetching data:", error);
                loader.hide();
            }
        },

        async fetchPreviousItems() {
            let loader = this.$loading.show({
                container: null,
                canCancel: false,
            });
            let firstDoc = this.tableData[0];
            firstDoc = await db.doc(`orders/${firstDoc.OrderNum}/items/${firstDoc._itemId}`).get();
            this.tableData = [];
            try {
                const querySnapshot = await this.itemsQueryRef
                    // .orderBy("created")
                    .orderBy("Timestamp", "asc") // Change to your sorting criteria
                    .startAfter(firstDoc)
                    .limit(this.pagination.perPage)
                    .get();

                this.tableData = await this.hydrateItems(querySnapshot).reverse();
                loader.hide();
            } catch (error) {
                console.error("Error fetching data:", error);
                loader.hide();
            }
        },


        onSelected(data) {
            this.selectedExportData = data;
        },


        closeImageModal() {
            this.showItemImagesModal = false;
            this.selectedFailedItem = {};
            this.selectedItemType = null;
        },



        async exportCSV(action) {
            const format_date = (v) => moment(v).format("MM/DD/YYYY");
            const loader = this.$loading.show({ container: null, canCancel: false });

            try {
                const { selectedExportData, searchedData } = this;
                const payload =
                    action === "all"
                        ? searchedData.length ? searchedData : await this.fetchAllItems()
                        : selectedExportData;

                const workbook = new ExcelJS.Workbook();
                const sheet = workbook.addWorksheet("QA Report");

                sheet.columns = [
                    { header: "Date", key: "date", width: 12 },
                    { header: "Order", key: "order", width: 16 },
                    { header: "Vendor", key: "vendor", width: 18 },
                    { header: "Purchase Orders", key: "purchaseOrders", width: 20 },
                    { header: "SKU", key: "sku", width: 18 },
                    { header: "Status", key: "status", width: 14 },
                    { header: "Rejections", key: "rejections", width: 40 },
                    { header: "Images", key: "images", width: 20 },
                    { header: "Shipped", key: "shipped", width: 40 },
                    { header: "Tracking #", key: "tracking", width: 40 },
                ];

                // Add rows to Excel
                payload.map(item => {
                    return {
                        date: format_date(item.Date),
                        order: `${item.OrderNum}-${item.LineNum}`,
                        vendor: (item.Vendor || "").replace(",", "."),
                        purchaseOrders: item.PO,
                        sku: item.SKU || item.ClientSKU || "",
                        status: item.Status || "",
                        rejections: item.Rejections.join(", ") || "",
                        imageLabel: item.Status === "Failed" ? item.CertOrItemNum : "",
                        imageUrl: item.Images?.length ? item.Images[0]?.url : "",
                        lineNum: item.LineNum, // for sorting,
                        shipped: item.HasBeenShipped ? `Shipped On ${format_date(item.ShippedOn)}` : 'Hasn\'t Been Shipped',
                        hasBeenShipped: item.HasBeenShipped,
                        tracking: item.HasBeenShipped ? item.TrackingNum : 'TBD'
                    };
                }).forEach((r) => {
                    const row = sheet.addRow(r);
                    row.getCell("images").value =
                        r.imageLabel || (r.imageUrl ? "View Image" : "");

                    if (r.imageUrl) {
                        const cell = row.getCell("images");
                        cell.value = { text: cell.value, hyperlink: r.imageUrl };
                        cell.font = { color: { argb: "FF0563C1" }, underline: true };
                    }


                    if (r.tracking && r.hasBeenShipped) {
                        const cell = row.getCell("tracking");
                        cell.value = { text: cell.value, hyperlink: `https://www.ups.com/track?loc=en_US&tracknum=${encodeURIComponent(r.tracking)}` };
                        cell.font = { color: { argb: "FF0563C1" }, underline: true };
                    }
                });

                // Formatting & Download
                sheet.views = [{ state: "frozen", ySplit: 1 }];
                sheet.getRow(1).font = { bold: true };

                const excelBuffer = await workbook.xlsx.writeBuffer({
                    useSharedStrings: true,
                });
                const blob = new Blob([excelBuffer], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });

                const url = URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = `QA Report ${moment().format("LL")}.xlsx`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            } catch (err) {
                loader.hide();
                console.error("Excel export failed:", err);
                alert("Export failed. Check console for details.");
            } finally {
                loader.hide();
                this.showExportOptions = false;
                this.showSelectableTable = false;
                this.selectedExportData = [];
            }
        },


        goBack(cur, prev) {
            this[cur] = false;
            this[prev] = true;
        },

        handleImageModal(url) {
            this.imageView = url;
            this.showImageModal = true;
        },

        clearFilters() {
            for (const key in this.filterBy) {
                if (key === "client" || key === "status") {
                    this.filterBy[key] = "";
                } else if (key === "startDate" || key === "endDate") {
                    this.filterBy[key] = null;
                    // this.filterBy[key] = "";
                } else if (
                    key === "showFailedItems" ||
                    key === "showPassedWithRepair" ||
                    key === "showPassedItems" ||
                    key === "showShippedItems" ||
                    key === "showPendingShipping" ||
                    key === "hidePendingQA"
                ) {
                    this.filterBy[key] = false;
                } else {
                    this.filterBy[key] = "";
                }
            }
            this.searchVal = "";
            this.resetTable();
        },

        async handleSearch(e) {
            // 1. Early Exit & Keyboard check
            if (e.keyCode !== 13 && e !== "click") return;

            const { selectedSearchBy } = this;
            let { searchVal } = this;

            if (!searchVal) {
                this.clearFilters();
                return;
            }

            try {
                let query = this.itemsQueryRef

                // 2. Apply Permission Scoping (The "Condition on Top")
                // This ensures that regardless of the search type, the user is restricted to their data.
                // 3. Handle specific search types

                if (selectedSearchBy === "on") {
                    // Order Number specific formatting
                    if (searchVal.includes("-")) searchVal = searchVal.split("-")[0];

                    // If searching by ID, it's more efficient to use .doc() directly
                    // ONLY if there are no other 'where' constraints.
                    // Otherwise, use .where("__name__", "==", id) to keep the query filters.
                    query = query.where("OrderNum", "==", searchVal);
                } else if (selectedSearchBy === "po") {
                    query = query.where("PO", "==", searchVal);
                } else if (selectedSearchBy === "sku") {
                    query = query.where("SKU", "==", searchVal);
                }

                // 4. Execution
                const snapshot = await query.get();

                // 5. Data Mapping
                if (snapshot.empty) {
                    Swal.fire("", "No Records Have Been Found", "error");
                    this.searchedData = [];
                } else {
                    // Handles both query snapshots and single doc results (via where name)
                    this.searchedData = await this.hydrateItems(snapshot)
                    this.searchedData = this.searchedData.sort((a, b) => b.Timestamp - a.Timestamp ? -1 : 1);
                }
            } catch (error) {
                console.error("Search Error:", error);
                Swal.fire("Error", "An error occurred while fetching data", "error");
            }
        },

        getDateRange() {
            const { startDate, endDate } = this.filterBy;
            const zone = getUserZone();
            return {
                start: startDate ? toZonedDate(startDate, zone).startOf("day").toMillis() : null,
                end: endDate ? toZonedDate(endDate, zone).endOf("day").toMillis() : null,
            };
        },

        buildFilterQuery() {
            const f = this.filterBy;
            let ref = this.itemsQueryRef;
            let hasFilter = false;
            const where = (field, op, value) => {
                ref = ref.where(field, op, value);
                hasFilter = true;
            };

            if (f.customers) where("Customer", "==", f.customers);
            if (f.client) where("Client", "==", f.client);
            if (f.showCertificateOrders) where("ServiceType", "==", CERT_SERVICE_TYPE);
            if (f.hidePendingQA) where("QCCompleted", "==", true);

            // Shipped + Pending together means "both", so no filter at all.
            if (!!f.showShippedItems !== !!f.showPendingShipping) {
                where("HasBeenShipped", "==", !!f.showShippedItems);
            }

            // Several status toggles = any of them (OR), not all of them (impossible).
            const statuses = Object.entries(STATUS_TOGGLES)
                .filter(([key]) => f[key])
                .map(([, status]) => status);
            if (f.status) statuses.push(f.status);
            const uniqueStatuses = [...new Set(statuses)];
            if (uniqueStatuses.length === 1) where("Status", "==", uniqueStatuses[0]);
            else if (uniqueStatuses.length > 1) where("Status", "in", uniqueStatuses);

            // Date range runs on the server, so only matching docs are read and hydrated.
            const { start, end } = this.getDateRange();
            if (start != null) where("Timestamp", ">=", start);
            if (end != null) where("Timestamp", "<=", end);

            return { ref: ref.orderBy("Timestamp", "desc"), hasFilter, start, end };
        },

        async handleFilter() {
            const { ref, hasFilter, start, end } = this.buildFilterQuery();

            if (!hasFilter) {
                this.resetTable();
                return false;
            }
            if (start != null && end != null && start > end) {
                return Swal.fire("Invalid dates", "Start date is after end date.", "warning");
            }

            // Ignore responses from older searches that finish after a newer one.
            // Works even if filterRequestId was never added to data() (avoids NaN !== NaN).
            this.filterRequestId = (this.filterRequestId || 0) + 1;
            const requestId = this.filterRequestId;
            const loader = this.$loading.show({ container: null, canCancel: false });

            try {
                const snap = await ref.get();
                if (requestId !== this.filterRequestId) return;

                if (snap.empty) {
                    this.searchedData = [];
                    this.clearFilters()
                    return Swal.fire("Empty Search Records");
                }

                const items = await this.hydrateItems(snap);
                if (requestId !== this.filterRequestId) return;
                this.searchedData = items;
            } catch (error) {
                console.error(error); // a missing-index error here includes a link to create it
                if (requestId === this.filterRequestId) {
                    Swal.fire(
                        "Internal Issue",
                        "Oops there seems to be an issue please try again or contact DIS support",
                        "warning",
                    );
                }
            } finally {
                loader.hide();
            }
        },

        validateDateRange(key) {
            if (moment(this.filterBy.startDate).isAfter(this.filterBy.endDate)) {
                this.filterBy.endDate = null;
            }

            if (key === "startDate") {
                this.filterBy.endDate = this.filterBy.startDate;
            }

            this.handleFilter()
        },


        handleViewModal(item) {
            this.selectedOrder = item;
            this.selectedOrderLineStatus = item.LineItems;
            this.$bind(
                "allLineItemsUnfiltered",
                db.collection(`orders/${item.id}/items`)
            );
            this.allLineItems = this.allLineItemsUnfiltered;
            this.showDialog = true;
        },

    },
};
</script>

<style scoped>
/* ===== Layout shell ===== */

.md-layout {
    display: flex;
    justify-content: center;
    background: #f5f4f8;
}

.md-layout-item {
    max-width: 90vw;
    margin: 24px auto 40px;
    position: relative;
}

/* ===== Generic QC card styling ===== */

.qc-card {
    border-radius: 14px;
    background: #ffffff;
    box-shadow: 0 4px 18px rgba(15, 23, 42, 0.06);
    margin-bottom: 16px;
}

.qc-search-card {
    padding-top: 4px;
}

.qc-filters-card {
    margin-bottom: 20px;
}

.qc-table-card {
    padding-top: 4px;
}

.qc-2 {
    height: 460px !important;
    overflow: auto;
    display: block;
}

/* ===== Search row / radios / input ===== */

.qc-search-row {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
    align-items: end;
}

.qc-search-left {
    min-width: 220px;
}

.qc-search-label {
    margin: 0 0 4px;
    font-size: 12px;
    font-weight: 500;
    color: #4b5563;
}

/* pill toggle for search-by radios */

.search-options ul {
    display: inline-flex;
    padding: 2px;
    border-radius: 999px;
    background: #f3f4f6;
    list-style: none;
    margin: 0;
}

.search-options li {
    position: relative;
    margin: 0;
}

.search-options input[type="radio"] {
    position: absolute;
    inset: 0;
    opacity: 0;
    cursor: pointer;
}

.search-options span {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 12px;
    cursor: pointer;
    color: #4b5563;
}

.search-options input[type="radio"]:checked+span {
    background: #253C6E;
    color: #f9fafb;
}

/* search input */

.qc-search-input-wrapper {
    flex: 1;
    min-width: 260px;
}

.qc-search-field {
    margin: 0;
}

.qc-search-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* ===== Buttons ===== */

.qc-btn {
    border-radius: 999px;
    padding: 6px 14px;
    font-size: 13px;
    text-transform: none;
}

.qc-btn-primary {
    background: #253C6E !important;
    color: #f9fafb !important;
}

.qc-btn-primary:hover {
    background: #020617 !important;
}

.qc-btn-secondary {
    background: #e5e7eb !important;
    color: #253C6E !important;
}

/* ===== Filters grid ===== */

.filters {
    display: flex;
    row-gap: 18px;
    align-items: flex-end;
    column-gap: 6%;
}

.filter p {
    margin: 0 0 4px;
    font-size: 12px;
    font-weight: 500;
    color: #4b5563;
}

.filter.customer {
    min-width: 200px;
}

.filter-status {
    grid-column: span 2;
}

.status-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px 10px;
    align-items: center;
    font-size: 12px;
}

.filter-row-extra {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
}

.filter-btn {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.bottom-row {
    padding-right: 10px;
    padding-left: 10px;
    display: flex;
    justify-content: space-between;
    align-items: end;
}

/* ===== Table card / Export row ===== */

.expand-toggle {
    margin-left: 4px;
}

.qc-details-row {
    background: #f9fafb;
}

.qc-details {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
    padding: 8px 4px 4px;
}

.qc-detail-group {
    min-width: 180px;
    max-width: 280px;
}

.qc-detail-group h4 {
    margin: 0 0 4px;
    font-size: 12px;
    font-weight: 600;
    color: #4b5563;
}

.qc-detail-group p {
    margin: 0;
    font-size: 12px;
    color: #253C6E;
}

.qc-details .item-sku-wrapper {
    max-width: 100%;
}

.qc-table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 15px;
}

.btn-row.stats_holder {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    width: 100%;
}

.qc-export-options {
    display: inline-flex;
    gap: 8px;
    flex-wrap: wrap;
}

/* wrapper so table can scroll horizontally if needed */

.qc-table-wrapper {
    max-height: 400px;
    margin-top: 8px;
    overflow-x: auto;
}

/* ===== Table look & feel ===== */
.qc-more-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 6px;
    margin-left: 4px;
    border-radius: 999px;
    font-size: 10px;
    background: #e5e7eb;
    color: #4b5563;
    white-space: nowrap;
}

.qc-table {
    font-size: 12px;
}

.qc-table thead {
    background: #f9fafb;
}

.qc-table thead tr th {
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 11px;
    color: white;
}

/* zebra / hover */

.qc-table tbody tr:nth-child(even) {
    background: #fafafa;
}

.qc-table tbody tr:hover {
    background: #f3f4ff;
}

/* Base table look */
.qc-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    background: #ffffff;
}

.qc-table thead {
    position: sticky;
    top: 0;
    z-index: 1;
    background: #f9fafb;
}

.qc-table thead th {
    text-align: left;
    padding: 8px 10px;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    font-size: 11px;
    color: white;
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
    white-space: nowrap;
}

.qc-table thead th:last-child {
    text-align: center;
    cursor: default;
    /* Controls header not sortable */
}

.qc-table tbody tr.qc-main-row td {
    padding: 8px 10px;
    /* border-bottom: 1px solid #f1f5f9; */
}

/* zebra + hover */
.qc-table tbody tr.qc-main-row:nth-child(4n + 1),
.qc-table tbody tr.qc-main-row:nth-child(4n + 2) {
    background: #ffffff;
}

.qc-table tbody tr.qc-main-row:nth-child(4n + 3),
.qc-table tbody tr.qc-main-row:nth-child(4n) {
    background: #fafafa;
}

.qc-table tbody tr.qc-main-row:hover {
    background: #f3f4ff;
}

.qc-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 15px;
    background: #fff;
}

.qc-table thead th {
    padding: 10px;
    text-transform: uppercase;
    color: white;
    border-bottom: 1px solid #e5e7eb;
    cursor: pointer;
}

.qc-main-row td {
    padding: 10px;
    /* border-bottom: 1px solid #f1f5f9; */
}

.qc-main-row:hover {
    background: #f3f4ff;
}

.qc-controls {
    text-align: right;
    white-space: nowrap;
}

.expand-btn {
    margin-left: 4px;
}

.qc-notes-cell {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 100px;
    max-width: 220px;
}

.data-list {
    max-height: 200px;
    width: 250px;
}

.data-list>ul {
    text-align: left;
    max-height: 200px;
    overflow: auto;
    max-width: 250px;
    border: solid black 0.5px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 5px;
}

.data-list>ul>li {
    width: 85px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* --- DETAILS DROPDOWN --- */

.details-wrapper td {
    padding: 0;
    background: #f9fafb;
    border-bottom: 1px solid #e5e7eb;
}

.details-content {
    padding: 0;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    /* padding: 14px 18px; */
    position: absolute;
    top: 11.2%;
    right: 0;
    z-index: 20;
}

.close-detail-window-btn {
    position: absolute;
    right: 0px;
    width: 20px;
    color: red;
    font-size: 20px;
    z-index: 999;
    top: -2px;
    cursor: pointer;
}

/* Subtable */
.qc-subtable {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
}

.qc-subtable th {
    width: 160px;
    text-align: left;
    padding: 6px 5px;
    color: #374151;
    font-weight: 600;
}

.qc-subtable td {
    padding: 6px 5px;
}

.qc-subtable ul {
    padding-left: 18px;
    margin: 0;
}

.slide-enter-active,
.slide-leave-active {
    transition: all 0.25s ease-out;
}

.slide-enter-from,
.slide-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

/* details row */
.qc-details-row td {
    padding: 8px 10px 10px;
    border-bottom: 1px solid #e5e7eb;
}

.qc-details-row {
    background: #f9fafb;
}

.qc-details {
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
}

.qc-detail-group {
    min-width: 180px;
    max-width: 280px;
}

.qc-detail-group h4 {
    margin: 0 0 4px;
    font-size: 12px;
    font-weight: 600;
    color: #4b5563;
}

.qc-detail-group p {
    margin: 0;
    font-size: 12px;
    color: #253C6E;
}

/* reuse chip list for SKUs / POs / Certs */
.qc-details .item-sku-wrapper {
    max-width: 100%;
}

/* numeric alignment */
.qc-num {
    text-align: right;
}

/* sort indicators */
.sort-icon {
    font-size: 9px;
    margin-left: 4px;
    opacity: 0.4;
}

.sorted-asc .sort-icon,
.sorted-desc .sort-icon {
    opacity: 1;
}

.sorted-asc .sort-icon::after,
.sorted-desc .sort-icon::after {
    content: "";
}

/* we can differentiate visually if you want later, but for now
   'sorted-asc' / 'sorted-desc' just bump opacity */

/* expand toggle button */
.expand-toggle {
    margin-left: 4px;
}

.action-btns {
    display: flex;
    justify-content: flex-end;
    gap: 4px;
}

.qc-table tbody tr td:last-child {
    text-align: right;
}

/* chip list for SKUs / POs / Certs */

.item-sku-wrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    max-width: 210px;
}

.item-sku-wrapper ol {
    list-style: none;
    padding: 0;
    margin: 0;
    display: contents;
}

.item-sku-wrapper li {
    display: inline-flex;
    padding: 2px 6px;
    border-radius: 999px;
    background: #f3f4f6;
    font-size: 11px;
    max-width: fit-content;
}

/* numeric alignment (Qty, Failed, etc.) */
.qc-table td,
.qc-table th {
    text-align: center !important;
}

/* ===== Existing styles you already had (kept) ===== */

.toggle_tabs {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    padding-bottom: 0;
    width: 97%;
    overflow: hidden;
    overflow-x: auto;
    margin: auto;
}

.toggle_tabs .tab {
    cursor: pointer;
    border: 2px solid #eaeaea;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1% 3%;
    border-radius: 0;
    background: transparent;
    border: none;
    font-weight: bold;
    border-bottom: 3px solid #eaeaea;
    text-transform: uppercase;
    color: rgba(27, 105, 111, 0.7);
}

.toggle_tabs .tab.active {
    background: #0024d6 !important;
    border-bottom: 3px solid #1f479a;
    padding: 1% 3%;
}

.toggle_tabs .tab.active p {
    color: white !important;
    font-size: 16px !important;
    font-weight: 700 !important;
}

.toggle_tabs .tab p {
    margin: 0;
    font-size: 16px !important;
    font-weight: 700 !important;
    padding: 1% 3%;
}

.results {
    height: 185px;
    width: 180px;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
}

.result-list-item {
    text-decoration: underline;
    margin-bottom: 0.2rem;
}

.result-list-item:hover {
    cursor: pointer;
    color: #0024d6;
}

.action-btns {
    display: flex;
}

.content {
    max-width: 100px;
}

.notes {
    width: fit-content;
    overflow-y: auto;
    display: flex;
    justify-content: center;
    max-height: 150px;
    padding: 10px;
    text-align: center;
}

.box-container-td {
    /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  height: 62px; */
}

.md-button {
    z-index: 0 !important;
}

.header {
    text-align: center;
    border-bottom: rgba(0, 0, 0, 0.49) dashed 0.5px;
}

.right {
    width: 50%;
}

.search-filter {
    position: sticky;
}

.image-container {
    display: flex;
    justify-content: center;
}

.sku-container {
    max-width: 100px;
    overflow-x: auto;
}

.no-image {
    border: 0.5px dashed black;
    height: 500px;
    width: 100%;
    text-align: center;
    font-size: 20px;
    padding-top: 28%;
}

.failed-item-row {
    font-weight: 900;
}

/* ===== Responsive tweaks ===== */

@media (max-width: 960px) {
    .qc-search-row {
        align-items: flex-start;
    }

    .filters {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }
}

@media (max-width: 640px) {
    .filters {
        grid-template-columns: 1fr;
    }

    .filter-status {
        grid-column: span 1;
    }

    .qc-search-row {
        flex-direction: column;
    }

    .qc-search-actions {
        width: 100%;
        justify-content: flex-end;
    }
}
</style>